<template>
  <div id="main-page">
    <div class="main-bg">
      <img class="d-none d-sm-block" :src="vendor.landingPageImgUrl.webImgUrl" alt="">
      <img class="d-block d-sm-none" :src="vendor.landingPageImgUrl.mobileImgUrl" alt=""> 
      <div class="align-center see-all-items">
        <b-btn class="primary-button" @click="searchProduct()">SEE ALL ITEMS</b-btn>
      </div>
    </div>
    <h1 class="featured-title">Top Recommendations</h1>
    
    <div v-for="(design, did) in featuredDesigns" :key="did" class="designs">
      <design-entry :design="design" @shop="gotoProduct"/>
    </div>
    <!-- <h1 class="featured-title">Top Picks</h1>
    <featured-stripe/> -->
    
    <footer-view/>

  </div>
</template>

<script>
import Product from '@/data/featuredProduct.json';
import FeatureService from '@/services/FeaturedService';
import FeaturedStripe from '@/components/homepage/FeaturedStripe.vue';
import DesignEntry from '@/components/homepage/designs/DesignEntry.vue';
import FooterView from '@/components/Footer.vue';
import vendors from '@/vendors';

export default {
  name: 'MainPage',
  components: {
    FeaturedStripe,
    DesignEntry,
    FooterView
  },
  data() {
    return {
      product: null,
      currentSection: 'homepage',
      featuredDesigns: [],
      vendor: vendors[window.location.host]
    };
  },

  methods: {
    getPath() {
      return require(`./../../assets/${this.vendor}-logo.png`);
    },
    gotoProduct(product) {
      this.$router.push(`/products/${product._id}`);
    },
    searchProduct() {
      this.$router.push({
        path: '/search',
        query: {
          term: this.searchTerm,
        },
      });
    },
  },

  created() {
    this.product = Product;
    FeatureService.getFeatureListFor(this.currentSection)
      .then((data) => {
        this.featuredDesigns = data;
      })
      .catch((err) => { console.log(err); });
  },
};
</script>

<style lang="scss">
@import '../../assets/css/global.scss';

.designs{
  margin-bottom: 1rem;
}
.veniqa-button:hover {
  background-color: $pitch-black;
  border: 2px solid $pitch-black;
}
.absolute-buttons {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-bottom: 100px;
}
#main-page{
  height: 100%;
}
.main-bg {
  // background-image: url('https://ourtourplannerpublic.s3.ap-southeast-1.amazonaws.com/restaurant_homepage/FOOD_DELIVERY.gif');
  //background-image: url('./../../assets/images/homepage.jpg');
  // height: 100%;
  // background-size: contain;
  // background-repeat: no-repeat;
  // background-position-x: center;
  position: relative;
  //width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  // .content {
  //   margin-top: 100px;
  //   display: flex;
  //   height: 100%;
  //   margin: auto;

  //   div {
  //     margin: auto;
  //   }
  // }
  display: flex;
  justify-content: center;
  img{
    // width: 100%;
    height: 100%;
  }
  .see-all-items{
    position: absolute;
    width: 100%;
    bottom: 5vh;
    .btn {
      padding: 1rem !important;
      font-weight: bold;
      outline: none;
      border: 0px;
    }
  }
}

.jumbotron {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
}
.featured-title {
  margin: 0px 0px 0px 0px;
  padding: 40px 10px;
  color: #5d6d7e;
  // background-color: #eaecee;
  font-family: 'Quicksand';
}
</style>
